
import axios from 'axios';
import { APIOverrides } from '../../ApiOverrides';
import type { PlayerFollowerProps, PublicPlayerProps, SmartSearchRequestProps } from '../../types';

let AUTH_SVC_API = ''
let SOCIAL_SVC_API = ''
//const ANALYTICS_SVC_API = 'https://be-analytics-svc.herokuapp.com';


export const PlayerRecommenderApi = {
    setEnvironment: () => {
        const endpoints = APIOverrides.getEndpoints();
        AUTH_SVC_API = endpoints['AUTH_SVC_API'] as string;
        SOCIAL_SVC_API = endpoints['SOCIAL_SVC_API'] as string;

    },
    smartSearch : async(search_request:SmartSearchRequestProps):Promise<PublicPlayerProps[]> => {
        try {
            const resp = await axios.post(`${AUTH_SVC_API}/v1/players/player/search/smart`, { search_request });
            return resp.data.players
        } catch (e) {
            return []
        }
    },
    getBulkPlayerfollowers: async(player_ids:string[]):Promise<PlayerFollowerProps[]> => {
        try {
            const resp = await axios.post(`${SOCIAL_SVC_API}/v1/followers/bulk/get`, { player_ids })
            return resp.data.player_followers   
        } catch (e) {
            return []
        }
    },
}
